export default __webpack_public_path__ + "static/media/Poppinspoppins-boldsemibold.7acd9d15.woff";